import { render, staticRenderFns } from "./ConcordiaGasLaws.vue?vue&type=template&id=0c3d6bdc&"
import script from "./ConcordiaGasLaws.vue?vue&type=script&lang=js&"
export * from "./ConcordiaGasLaws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports